import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

import OverviewCard from "components/Dashboard/Overview/OverviewCard";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCartOutlined";
import PeopleIcon from "@material-ui/icons/PeopleOutlined";
import BarChartIcon from "@material-ui/icons/BarChartOutlined";
import LayersIcon from "@material-ui/icons/LayersOutlined";
import { CircularProgress } from "components/UI/Progress";
import { ReactComponent as LogoA } from 'assets/dashboard/equipments.svg';
import { ReactComponent as LogoB } from 'assets/dashboard/iconfinder.svg';
import { ReactComponent as LogoC } from 'assets/dashboard/outline_bar_chart.svg';
import { ReactComponent as LogoD } from 'assets/dashboard/outline_dashboard.svg';
import { ReactComponent as LogoE } from 'assets/dashboard/outline_layers.svg';
import { ReactComponent as LogoF } from 'assets/dashboard/outline_people.svg';

const styles = theme => ({
  root: {
    display: "flex",
    flex: 1,
    margin: theme.spacing.unit * 2,
  },
  icon: {
    fontSize: 48,
    color: "#236192",
  },
});

class Dashboard extends React.PureComponent {
  render() {
    const {
      classes,
      isLoading,
      customers,
      equipments,
      regions,
      notifications,
      schedulers,
    } = this.props;

    if (isLoading)
      return (
        <div className={classes.root}>
          <CircularProgress />
        </div>
      );

    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={3}>
            <OverviewCard
              icon={<LogoF/>}
              title={"Customers"}
              value={customers}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <OverviewCard
              icon={<LogoA className={classes.icon} />}
              title={"Equipments"}
              value={equipments}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <OverviewCard
              icon={<LogoC className={classes.icon} />}
              title={"Regions"}
              value={regions}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <OverviewCard
              icon={<LogoE className={classes.icon} />}
              title={"Notifications"}
              value={notifications}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <OverviewCard
              icon={<LogoB className={classes.icon} />}
              title={"Scheduler"}
              value={schedulers}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(Dashboard);
